const TG_PURPOSES = [
  'Holidays',
  'Tourism',
  'Business trip',
  'Trade',
  'Family visit',
  'Family reunification',
  'Official visit',
  'Official mission',
  'Professional mission',
  'Humanitarian mission',
  'Studies',
  'Traineeship',
  'Job',
  'Follow-up of your company based in Togo',
  'Conference/Seminar/Workshop',
  'Sanitary Emergencies/health care',
  'Resident',
  'Courtesy visa',
  'Other'
].map((label) => ({ label, value: label }))

const TG_BORDERS = [
  { label: 'Benin', value: 'Benin' },
  { label: 'Burkina-faso', value: 'Burkina-faso' },
  { label: 'Ghana', value: 'Ghana' }
]

const TG_BORDER_POSTS = [
  // Benin
  'SANVEE CONDJI',
  'TOHOUN',
  'AGOMEGLOUZOU',
  'MATCHATOM',
  'NIAMTOUGOU',
  'SOUDOU',
  'NADOBA',
  'KEMERIDA',
  // Burkina-faso
  'CINKASSE',
  'PONIO',
  // Ghana
  'AFLAO',
  'NOEPE',
  'SEGBE',
  'KPADAPE',
  'KOULFIEKOU',
  'NATCHAMBA'
].map((label) => ({ label, value: label }))

const TG_ENTRY_TYPE = {
  type: 'buttons',
  props: {
    options: [
      { icon: 'icon-air', label: 'Air', value: 'air' },
      { icon: 'icon-sea', label: 'Sea', value: 'sea' },
      { icon: 'icon-land', label: 'Land', value: 'land' }
    ]
  }
}

export const TG_FIELDS = {}

export const TG_APPLICATION_FIELDS = {
  purpose: {
    type: 'select',
    props: {
      label: 'Purpose of Travel',
      options: TG_PURPOSES
    }
  },
  entry_type: TG_ENTRY_TYPE,
  exit_type: TG_ENTRY_TYPE,
  entry_airport: {
    type: 'input',
    props: {
      label: 'Airport of Entry',
      maxLength: 100
    }
  },
  entry_airline: {
    type: 'input',
    props: {
      label: 'Airline',
      maxLength: 100
    }
  },
  exit_airport: {
    type: 'input',
    props: {
      label: 'Airport of Departure',
      maxLength: 100
    }
  },
  exit_airline: {
    type: 'input',
    props: {
      label: 'Airline',
      maxLength: 100
    }
  },
  entry_border: {
    type: 'select',
    props: {
      label: 'Border of Entry',
      options: TG_BORDERS
    }
  },
  exit_border: {
    type: 'select',
    props: {
      label: 'Border of Departure',
      options: TG_BORDERS
    }
  },
  entry_border_post: {
    type: 'select',
    props: {
      label: 'Border Post',
      options: TG_BORDER_POSTS
    }
  }
}
